import { Platform } from 'react-native';

/**
 * Canonical colour palette for the Topicus Events app.
 */
const Colors = {
	// Brand
	primary: '#F1EA36',
	secondary: 'rgba(14, 127, 195, 1)',

	// Neutrals
	white: '#fff',
	black: '#030303',
	blackPure: '#000000',

	// Greys, named by role (light → dark)
	greyBg: '#F6F8FA',
	greyBgAlt: '#EDF0F3',
	greyBorder: '#e5e7eb',
	greyDivider: '#ddd',
	greyIcon: '#C7C7CC',
	greyText: '#BBBBBB',
	// Secondary text that still has to be readable: 5.3:1 on white, where greyText sits at 1.9:1 and only suits
	// disabled or decorative use.
	greySecondaryText: '#6B6B6B',
	greyDark: '#77818B',
	greyTextDark: '#404040',
	greyHeader: '#002959',
	greyTab: '#757575',
	greySubtle: '#c9c8cd',
	greyLine: '#c9c9c9',

	// Semantic
	red: '#E61515',
	redAlt: '#ff0000',
	redError: '#D50000',
	green: '#64C718',
	greenAlt: '#1ABC59',
	yellowAccent: '#FAE534',
	yellowSecondary: '#F4EA00',
	orange: '#FFB220',

	// Platform-aware convenience (kept for backwards compat)
	lightGrey: Platform.OS === 'android' ? 'rgba(0, 0, 0, 0.38)' : '#BBBBBB',
	darkGrey: Platform.OS === 'android' ? 'rgba(0, 0, 0, 0.54)' : '#77818B',
	greyPlatform: Platform.OS === 'ios' ? '#8E8E93' : '#767676',

	transparent: 'transparent',

	// Semi-transparent overlays, suffix = alpha percentage
	overlay10: 'rgba(0,0,0,0.10)',
	overlay12: 'rgba(0,0,0,0.12)',
	overlay15: 'rgba(0,0,0,0.15)',
	overlay30: 'rgba(0,0,0,0.30)',
	overlay42: 'rgba(0,0,0,0.42)',
	overlay50: 'rgba(0,0,0,0.50)',
	overlay54: 'rgba(0,0,0,0.54)',
	whiteOverlay: 'rgba(255,255,255,0.80)',
	blackOverlay: 'rgba(0,0,0,0)',

	// Background tints used in timetable / archive views
	greyBgLight: '#F7F8FA',
};

export default Colors;
